import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class ResourceDashboardService extends BaseService {
  fetchResourceDashboard = ({ timeStart, teamSlot1Id, teamSlot2Id, teamTaskId }) => {
    return this.axios.get(API_ENDPOINTS.RESOURCE_DASHBOARD, {
      params: {
        timeStart,
        teamSlot1Id,
        teamSlot2Id,
        teamTaskId,
      },
    });
  };
}
